module.exports = __webpack_public_path__ + "img/demigods_320.6900f401.png";